import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../context/UserPrefs/UserPrefsContext";
import { Link } from "react-router-dom";
import "./EVCard.scss";

import RenderItem from "../RenderItem/RenderItem";
import VehicleImage from "./../VehicleImage/VehicleImage";

import calcMatchScore from "../../functions/vehicle/MatchScore/calcMatchScore";
import getPaymentDetails from "../../functions/vehicle/getPaymentDetails";
import { FormatAsDollars, FormatCarModelAndTrim } from "./../../utils/Helpers/Format";


import IconBEV from "./../../client_customizations/assets/images/icons/icon-electric.png";
import IconPHEV from "./../../client_customizations/assets/images/icons/icon-hybrid.png";
// import IconLocal from "./../../client_customizations/assets/images/icons/icon-local.png";
import isBEV from "../../functions/vehicle/isBEV";
import isPHEV from "../../functions/vehicle/isPHEV";
import Monroney from "./../../client_customizations/assets/images/icons/monroney"
import lightning from "./../../client_customizations/assets/images/icons/DTE_Lightning_Bolt.png"

import gasCan from "./../../client_customizations/assets/images/icons/MultiLayerGasCan.png"
import {FormattedMessage, useIntl} from 'react-intl';



const EVCard = ({
  ev,
  hasEvDetails,
  hasIncentivesAndMatchScore,
  hasLinkToEv,
  // hasLocallyAvailableHidden
}) => {
  const intl = useIntl()
  const userPrefs = useContext(UserPrefsContext);
  
  if (!ev) return null;

    let evImgs = ev.images ? ev.images.map( (n) =>
                  (n.url_thumbnail == null) ?  [] : 
                  (n.url_full == null) ?  []: 
                  [n]) : [];


  //Flatten evImgs into a single array                  
  const evImgSrc = [].concat.apply([], evImgs);


  const imgSrc = ev.images ? (ev.images.length >= 0 ? evImgSrc[0] : "") : "";
  const paymentDetails = getPaymentDetails(
    ev,
    userPrefs.get("monthsOfOwnership"),
    userPrefs.get("interestRateAsBasisPoints"),
    userPrefs.get("milesDrivenAnnually"),
    userPrefs.get("salesTax")
  );
  const afterIncentives = paymentDetails.afterIncentives
    ? paymentDetails.afterIncentives
    : 0;

  // const renderLocalIcon = ev.locally_available ? (
  //   <span className="badge-locally-available">
  //     <img alt="Available Locally" src={IconLocal} />
  //   </span>
  // ) : null;

  const renderFuelTypeBadge = isBEV(ev) ? (
    <span className="badge-fuel-type">
      <img alt="All-Electric" src={IconBEV} />
    </span>
  ) : isPHEV(ev) ? (
    <span className="badge-fuel-type">
      <img alt="Hybrid" src={IconPHEV} />
    </span>
  ) : null;

  let altText = "Go to " +(ev.make + " " + ev.model + " " + ev.trim).toString().trim(); 


  const renderEVDetails = hasEvDetails ? (
    <>
    <div className="container">
      <div className="row">
        <div className="col-2 fuel-type-holder">
            <span>
              <img className="electric-type" src={lightning} alt="lightning bolt"></img>
            </span>
        </div>
        <div className="col-4">
          <div className="milage row">
            <div className="col range">{ev.electric_range}</div>
            <div className="col type">electric</div>
          </div>
        </div>
        {isPHEV(ev) && 
        <>
        <div className="col-2 fuel-type-holder">
            <span>
              <img className="gas-type" src={gasCan} alt="gas can"></img>
            </span>
        </div>
        <div className="col-4">
          <div className="milage row">
            <div className="col range">{ev.total_range - ev.electric_range}</div>
            <div className="col type">gasoline</div>
          </div>
        </div>
        </>
        }
      </div>
    </div>

    <div className="renderRowOfData row">
      <Monroney electricRange={ev.electric_range} totalRange={ev.total_range} isBEV={isBEV(ev)}/>
    </div>
    </>
  ) : null;

  const renderCardBottom = hasIncentivesAndMatchScore ? (
    <div className="EVCardBottom">
      <div>
        <RenderItem
          title={intl.formatMessage({ id: "vehicle.afterIncentives", defaultMessage: "AFTER INCENTIVES"})}
          value={FormatAsDollars(afterIncentives)}
        />
      </div>
      <div>
        <RenderItem
          title={intl.formatMessage({ id: "evCard.matchScore", defaultMessage: "MATCH SCORE"})}
          value={calcMatchScore(
            ev,
            userPrefs.get("milesDrivenDaily"),
            userPrefs.get("chargerLevel"),
            userPrefs.get("maxBudget"),
            userPrefs.get("minSeats"),
            userPrefs.get("monthsOfOwnership"),
            userPrefs.get("interestRateAsBasisPoints"),
            userPrefs.get("milesDrivenAnnually"),
            userPrefs.get("salesTax")
          )}
          matchScore
        />
      </div>
    </div>
  ) : (
    hasLinkToEv && (
      <div className="EVCardBottomWithLink">
        <Link
          to={`${"/vehicles/" + ev.handle}`}
          className="btn btn-ae"
          target="_blank"
          style={{ outline: "none" }}
        >
          <FormattedMessage 
            id="evCard.seeElectricVehicle"
            defaultMessage="SEE ELECTRIC VEHICLE"
            description="SEE ELECTRIC VEHICLE"
          />
        </Link>
      </div>
    )
  );

  return (
    <>
      <div className="EVCardTop">
        {/* {!hasLocallyAvailableHidden && renderLocalIcon} */}
        {renderFuelTypeBadge}
        <p className="h2" style={{ maxWidth: "70%" }}>
          {ev.make}
        </p>
        <p className="h3 mt-1">
          {FormatCarModelAndTrim(ev)}   
        </p>
        <div className="text-center">
          <VehicleImage image={imgSrc} size="thumb" alt={altText} />
        </div>
        {renderEVDetails}
      </div>
      {renderCardBottom}
    </>
  );
};

export default EVCard;

EVCard.propTypes = {
  ev: PropTypes.object,
  hasEvDetails: PropTypes.bool,
  hasIncentivesAndMatchScore: PropTypes.bool,
  hasLinkToEv: PropTypes.bool,
  hasLocallyAvailableHidden: PropTypes.bool
};
